export { default as Header } from "./Header";
export { default as Banner } from "./Banner";
export { default as Text } from "./Text";
export { default as Button } from "./Button";
export { default as CardProcess } from "./CardProcess";
export { default as CardSolution } from "./CardSolution";
export { default as DownloadApps } from "./DownloadApps";
export { default as OurLoyalCustomer } from "./OurLoyalCustomer";
export { default as ApplyNow } from "./ApplyNow";
export { default as LeadFormModal } from "./LeadFormModal";
